export class LocalUseField {
	Active: boolean;
	BLC: string;
	Description: string;
	EntityType: string;
	EntityId: number;
	FieldName: string;
	FieldValue: string;
	OriginalFieldValue: string;
	Id: number;
	Priority: number;
	LimitToList: boolean;
	LocalUseFieldDataId: number;
	IsReferenced: boolean;
	Required: boolean;
	IsDirty: boolean;
	IsDeleted: boolean;
	ValueList: string;
	GroupName: string;
	ListOfValues: string[];

	constructor(inValues?: Partial<LocalUseField>) {
		Object.assign(this, inValues);
		this.OriginalFieldValue = this.FieldValue ? this.FieldValue : '';
		if (inValues.ValueList) {
			this.ListOfValues = JSON.parse(inValues.ValueList);
		}
	}

	get GroupNameFormatted(): string {
		return !this.GroupName || this.GroupName.length === 0 ? 'Misc.' : this.GroupName;
	}

	public get isAutocomplete(): boolean {
		return this.ListOfValues && this.ListOfValues.length > 0;
	}
}
